import styled, { css } from 'styled-components';

const Footer = styled.div(
  ({ theme }) => css`
    margin: 0;
    padding: 1rem 0 0 0;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    border-top: 1px solid ${theme.border.default};
    flex-shrink: 0;
  `
);

interface ModalFooterProps {
  children: React.ReactNode;
}

export function ModalFooter({ children }: ModalFooterProps) {
  return <Footer>{children}</Footer>;
}
